export class Job {
  static COMPLETE = 'complete';
  static FAILED = 'failed';
  static IN_PROGRESS = 'in-progress';

  constructor(
    public jobId: string,
    public status: string,
    public jobType: string,
    public created: string,
    public updated: string,
    public completed: string,
    public siteId: string,
    public stageId: string,
  ) {}

  public static fromApi(job: JobReply): Job {
    return new Job(
      job.job_id,
      job.status,
      job.job_type,
      job.created,
      job.updated,
      job.completed,
      job.site_id,
      job.stage_id,
    );
  }
}

export interface JobResponseJSON {
  data: JobReply;
}

export interface JobsResponseJSON {
  data: JobsReply;
}

interface JobReply {
  job_id: string;
  status: string;
  job_type: string;
  created: string;
  updated: string;
  completed: string;
  site_id: string;
  stage_id: string;
}

interface JobsReply {
  cursor_string: string;
  jobs: [JobReply];
}
